export const navigation = [
  { label: "O firmě", href: "#o-firme" },
  { label: "Služby", href: "#sluzby" },
  { label: "Postup", href: "#postup" },
  { label: "Reference", href: "#reference" },
  { label: "FAQ", href: "#faq" },
  { label: "Kontakt", href: "#kontakt" },
] as const;

export const footerNavigation = {
  services: {
    title: "Služby",
    items: [
      { label: "Elektroinstalace", href: "#sluzby" },
      { label: "Revize", href: "#sluzby" },
      { label: "BOZP a PO", href: "#sluzby" },
      { label: "Správa nemovitostí", href: "#sluzby" },
    ],
  },
  info: {
    title: "Informace",
    items: [
      { label: "O firmě", href: "#o-firme" },
      { label: "Postup", href: "#postup" },
      { label: "Reference", href: "#reference" },
      { label: "FAQ", href: "#faq" },
      { label: "Ochrana osobních údajů", href: "#kontakt" },
    ],
  },
} as const;

export type NavigationItem = (typeof navigation)[number];
